
import { useState, useEffect } from 'react';
import { getDecimalEnums } from "@/services/decimalEnumService";
import { db } from "@/services/firebaseService";
import { DecimalEnum } from "@/types/fieldsOptions";

interface IncrementOption {
  value: string;
  label: string;
}

export const useIncrementOptions = () => {
  const [incrementOptions, setIncrementOptions] = useState<IncrementOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchIncrementOptions = async () => {
      try {
        setLoading(true);
        console.log("[useIncrementOptions] Fetching increment options from decimalEnums");
        
        const allDecimalEnums = await getDecimalEnums(db);
        console.log("[useIncrementOptions] All decimal enums:", allDecimalEnums);
        
        const filteredIncrements = allDecimalEnums
          .filter(item => item.type === "offerIncrement")
          .sort((a, b) => a.value - b.value);
        
        console.log("[useIncrementOptions] Filtered increment enums:", filteredIncrements);
        
        const options = filteredIncrements.map((item: DecimalEnum) => ({
          value: item.id,
          label: item.longLabel || item.shortLabel || item.id
        }));
        
        // Ensure the "None selected" option is first
        const noneOption = options.find(opt => opt.value === "oi_none");
        const otherOptions = options.filter(opt => opt.value !== "oi_none");
        
        const sortedOptions = noneOption 
          ? [noneOption, ...otherOptions] 
          : [{ value: "oi_none", label: "None selected" }, ...otherOptions];
        
        console.log("[useIncrementOptions] Final sorted options:", sortedOptions);
        setIncrementOptions(sortedOptions);
      } catch (err) {
        console.error("[useIncrementOptions] Error fetching increment options:", err);
        setError(err instanceof Error ? err : new Error(String(err)));
        
        // Fallback to default
        setIncrementOptions([
          { value: "oi_none", label: "None selected" }
        ]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchIncrementOptions();
  }, []);

  return { incrementOptions, loading, error };
};
